import gql from "graphql-tag"

export const CREATE_BOOKING_WITH_SCHEDULED_PAYMENTS = gql`
    mutation CreateBookingWithScheduledPayments($newBookingData: NewBookingInput!, $sendMail: Boolean!, $onlineBooking: Boolean!) {
        createBooking(newBookingData: $newBookingData, sendMail: $sendMail, onlineBooking: $onlineBooking) {
            id
            bookingType
            scheduledPayments {
                id
                paymentDone
                paymentAmount
            }
        }
    }
`

export const GET_BOOKING_BY_ID = gql`
    query getBookingById($id: ID!) {
        bookingById(id: $id) {
            id
            bookingNumber
            bookingNumberPrefix
            grossPrice
            discount
            discountName
            courseLessons {
                id
            }
            attendee {
                id
                firstname
                lastname
            }
            course {
                id
                prefixedCourseNumber
                startDateTime
                courseType {
                    id
                    name
                }
            }
            paymentMethod {
                id
                type
            }
            paymentType
            payDate
            scheduledPayments {
                id
                paymentDone
                paymentAmount
                molliePaymentStatus
                mollieMethod
            }
        }
    }
`

export const GetAvailablePaymentMethodsFromEndUserApp = gql`
    query GetAvailablePaymentMethodsFromEndUserApp($courseId: ID) {
        getAvailablePaymentMethodsFromEndUserApp(courseId: $courseId) {
            id
            description
            imageUrl
            isEnabled
            isAvailableInProfile
        }
    }
`

export const InitiateMolliePaymentForBookingFromEndUserApp = gql`
    mutation InitiateMolliePaymentForBookingFromEndUserApp(
        $bookingId: ID!
        $method: String!
        $scheduledPaymentId: ID
        $locale: String
        $returnBaseUrl: String
    ) {
        initiateMolliePaymentForBookingFromEndUserApp(
            bookingId: $bookingId
            method: $method
            scheduledPaymentId: $scheduledPaymentId
            locale: $locale
            returnBaseUrl: $returnBaseUrl
        ) {
            molliePaymentId
            checkoutUrl
            status
        }
    }
`

export const MolliePaymentStatusFromEndUserApp = gql`
    query MolliePaymentStatusFromEndUserApp($scheduledPaymentId: ID!) {
        molliePaymentStatusFromEndUserApp(scheduledPaymentId: $scheduledPaymentId) {
            molliePaymentId
            status
            failureReason
            paidAt
            expiresAt
            amount
            amountDetails {
                value
                currency
            }
            bankTransferDetails {
                recipient
                iban
                bic
                reference
            }
            # Ausweg-Links fuer den Bucher waehrend der offenen Ueberweisung:
            # statusUrl -> Mollie-Statusseite ("Zahlungsstatus pruefen"),
            # payOnlineUrl -> Checkout fuer eine andere Zahlart ("Andere Zahlart waehlen").
            statusUrl
            payOnlineUrl
            # Checkout-URL des offenen Versuchs -> "Jetzt bezahlen" auf der Rueckkehr-Seite.
            checkoutUrl
            # Phase 26.1 / Fix #3 — Cross-Device-Retry-Fallback-Felder.
            # Genutzt von der PaymentReturn-Page, wenn der Bucher die Reminder-
            # Mail in einem anderen Browser/Geraet oeffnet und der lokale
            # mollie-pending-payment-Eintrag im localStorage fehlt.
            bookingId
            availableMollieMethods
            courseTitle
            courseStartDate
        }
    }
`

// Auth-freie Variante fuer Dispatch-Zahlungslinks: Der Bucher klickt einen per
// E-Mail versendeten Mollie-Link und ist NICHT in der EUA eingeloggt. Die
// auth-gegatete Query oben liefert fuer ihn UNAUTHENTICATED; deshalb nutzt die
// PaymentReturn-Page diese Public-Query, wenn kein accessToken vorliegt.
// Der Rueckgabetyp MolliePaymentStatusPublic liefert inzwischen ebenfalls die
// Ueberweisungsdaten (bankTransferDetails/expiresAt) sowie die Ausweg-Links
// (statusUrl/payOnlineUrl), damit auch ausgeloggte Bucher ihre Bankdaten sehen.
// Bewusst NICHT enthalten bleiben bookingId und availableMollieMethods
// (auth-pflichtige Retry-/Method-Picker-Features).
export const MolliePaymentStatusFromEndUserAppPublic = gql`
    query MolliePaymentStatusFromEndUserAppPublic($scheduledPaymentId: ID!) {
        molliePaymentStatusFromEndUserAppPublic(scheduledPaymentId: $scheduledPaymentId) {
            molliePaymentId
            status
            failureReason
            paidAt
            expiresAt
            amount
            amountDetails {
                value
                currency
            }
            bankTransferDetails {
                recipient
                iban
                bic
                reference
            }
            statusUrl
            payOnlineUrl
            # Checkout-URL des offenen Versuchs -> "Jetzt bezahlen" auf der Rueckkehr-Seite.
            checkoutUrl
            courseTitle
            courseStartDate
        }
    }
`
